import { Col, message, Row } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { createReplacementTransportPlan } from "../../../../lib/api/resources/replacementTransports";
import {
  ReplacementTransportPlanFormCard,
  ReplacementTransportPlanInputDto,
} from "./components/ReplacementTransportPlanFormCard";

export const ReplacementTransportPlanCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createReplacementTransportPlanMutation = useMutation({
    mutationFn: (data: ReplacementTransportPlanInputDto) =>
      createReplacementTransportPlan(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["replacementTransportPlans"],
      });
      message.success("Vervangend vervoer plan succesvol aangemaakt");
      navigate("/replacement-transport/plans");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het aanmaken van het vervangend vervoer plan",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <ReplacementTransportPlanFormCard
          mutation={createReplacementTransportPlanMutation}
        />
      </Col>
    </Row>
  );
};
